import React from 'react';
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys';
import flow from 'lodash/fp/flow';
import { WorkbookState } from 'types';
import PdfViewer from './PdfViewer';

type Props = {
  workbook: WorkbookState;
  fingerprint?: string | null;
  pdfScaleValue: number;
};

const SinglePageViewer: any = (props: Props) => {
  return <PdfViewer {...props} />;
};

export default flow(onlyUpdateForKeys(['currentPage', 'fingerprint']))(SinglePageViewer) as any;
